import * as angular from 'angular';
import { ConstantItems } from "../../constants";
import { EmailDetails } from "./models/emailDetails";

export class EmailRepo {

  /** @ngInject */
  constructor(private $http: angular.IHttpService, private config: ConstantItems) { }

  getGroupEmails() {
    return this.$http.get(`${this.config.emailUrl}/groups/emails`)
      .then(resp => resp.data as EmailDetails[])
  }

  sendGroupEmail(groupEmailRequest: FormData) {
    return this.$http.post(`${this.config.emailUrl}/groups/emails`,
      groupEmailRequest,
      {
        headers: {
          'Content-Type': undefined
        },
        transformRequest: angular.identity
      })
  }

  downloadAttachment(attachmentId) {
    return this.$http.get(`${this.config.emailUrl}/groups/emails/attachment/${attachmentId}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/bulkemailing/email.repo.ts